import React, { useEffect, useState } from "react";
import { Table, Spin, Button } from "antd";
import LoadingOverlay from "../shared/LoadingOverlay";
import Toast from "../shared/Toast";

export default function MilestoneValidationPage() {
    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");
    const [toastVisible, setToastVisible] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("success");
    const [auditData, setAuditData] = useState([]);

    useEffect(() => {
        const fetchDataAudits = async () => {
            try {
                setLoading(true);
                setLoadingText("Fetching Loan Data Audits...");

                // Updated dummy data
                const dummyData = [
                    {
                        key: 1,
                        type: "Warning",
                        fieldId: "541",
                        auditDescription:
                            "If field 541 (Flood Zone) is a code that is in a flood zone or indeterminate, the Executed Flood Notice must be received at least 10 days prior to closing date."
                    },
                    {
                        key: 2,
                        type: "Fatal",
                        fieldId: "3978",
                        auditDescription:
                            "Field 3978 (CD Received Date) must have a value and the Estimated Closing Date must be on or after the Earliest Available Closing Date."
                    }
                ];

                await new Promise((resolve) => setTimeout(resolve, 1000)); // simulate delay
                setAuditData(dummyData);
            } catch (err) {
                console.error("Error fetching audits", err);
                setToastMessage("Failed to fetch audit data.");
                setToastType("error");
                setToastVisible(true);
            } finally {
                setLoading(false);
                setLoadingText("");
            }
        };

        fetchDataAudits();
    }, []);

    const columns = [
        {
            title: "TYPE",
            dataIndex: "type",
            key: "type",
            width: "20%",
            render: (text) => {
                let buttonType = "default";
                let buttonStyle = {};

                if (text === "Warning") {
                    buttonType = "default";
                    buttonStyle = {
                        backgroundColor: "#facc15", // yellow-400
                        color: "#000",
                        border: "none"
                    };
                } else if (text === "Fatal") {
                    buttonType = "default";
                    buttonStyle = {
                        backgroundColor: "#dc2626", // red-600
                        color: "#fff",
                        border: "none"
                    };
                }

                return (
                    <Button
                        type={buttonType}
                        size="small"
                        style={{
                            ...buttonStyle,
                            borderRadius: "6px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            padding: "0 10px",
                            height: "24px",
                            lineHeight: "24px"
                        }}
                    >
                        {text}
                    </Button>
                );
            }
        },
        {
            title: "FIELD ID",
            dataIndex: "fieldId",
            key: "fieldId",
            width: "30%",
            render: (text) =>
                text ? (
                    <span className="text-blue-600">
                        {text}
                    </span>
                ) : (
                    "-"
                )
        },
        {
            title: "AUDIT DESCRIPTION",
            dataIndex: "auditDescription",
            key: "auditDescription",
            width: "50%"
        }
    ];

    return (
        <div className="space-y-10 p-6">
            <div className="bg-white rounded-lg p-4 space-y-6 shadow max-w-7xl mx-auto">
                <LoadingOverlay loading={loading} text={loadingText} />

                <div className="text-xl font-semibold text-gray-800 border-b pb-2">
                    Loan Audit
                </div>

                {loading ? (
                    <div className="flex justify-center items-center h-40">
                        <Spin size="large" />
                    </div>
                ) : (
                    <Table
                        size="middle"
                        bordered
                        columns={columns}
                        dataSource={auditData}
                        pagination={false}
                    />
                )}

                <Toast
                    visible={toastVisible}
                    type={toastType}
                    message={toastMessage}
                    onClose={() => setToastVisible(false)}
                />
            </div>
        </div>
    );
}